import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSeo from '@/hooks/useSeo';
import Hero from './components/Hero';
import AttorneyIntro from './components/AttorneyIntro';
import PracticePreview from './components/PracticePreview';
import ContactCta from './components/ContactCta';

export default function Home() {
  useSeo({
    title: 'Bufete Ramos Santos | Abogados en Heredia, Costa Rica',
    description:
      'Abogados en Heredia con más de 25 años de experiencia en derecho de familia, penal, civil y notarial. Atención directa del Máster León Felipe Ramos Santos.',
    keywords:
      'abogados Heredia, bufete Heredia, abogado de familia Costa Rica, abogado penalista Heredia, notario Heredia',
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <AttorneyIntro />
        <PracticePreview />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}